import {trigger, style, transition, animate, keyframes, query, stagger} from '@angular/animations';
import {Component, ViewChild, Input, OnInit, OnDestroy, AfterViewInit, OnChanges, ViewEncapsulation} from '@angular/core';
import {Page} from '../page';
import {PagesService} from '../../services/pages.service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {MenuService} from '../../services/menu.service';
import {Observable} from 'rxjs/Rx';
import {UIService} from '../../services/ui.service';
import {AppConfig} from '../../app-config.service';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';
import {ElementRef} from '@angular/core';

@Component({
  selector: 'app-page-single',
  templateUrl: './page-single.component.html',
  styleUrls: ['./page-single.component.scss'],
  providers: [PagesService],
  encapsulation: ViewEncapsulation.None,
})

export class PageSingleComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  public slug: string = null;
  public content: any[];
  public pageCssClass: string;
  public showBlogHeading: boolean;
  public showIframes: boolean = false;
  public iframeClass: string = '';

  public postTitle: string;
  public postDate: Date;
  public postAuthor: string;

  public abstractView: boolean = true;
  public showImages: boolean = false;

  constructor(private pagesService: PagesService,
              public ui: UIService,
              private route: ActivatedRoute,
              private scrollToService: ScrollToService,
              private elementRef: ElementRef,
              private router: Router) {
  }

  private enableAnchorScrolls() {
    let buttons: any[] = this.elementRef.nativeElement.querySelectorAll('.smooth-scroll-button');
    for (let button of buttons) {
      let destinationId = button.getAttribute('data-smooth-scroll-destination');
      if (destinationId) {
        button.addEventListener('click', () => {
          this.triggerScrollTo(destinationId);
        });
      }
    }
  }

  public triggerScrollTo(destinationId: string) {

    const config: ScrollToConfigOptions = {
      //container: 'custom-container',
      target: destinationId,
      duration: 800,
      easing: 'easeInCubic',
      //offset: 20
    };

    this.scrollToService.scrollTo(config);
  }


  public makeAbstract(state) {
    console.log('makeAbstract ' + this.slug, state);
    this.abstractView = state;
    this.showImages = !state;
  }

  getContent(parentSlug) {

    this.pagesService
      .getPage(parentSlug)
      .subscribe(res => {
          let pageData: Page = (res[0] as Page);
          this.slug = parentSlug;
          this.content = pageData.acf.page_content;
          //prep multidim array of column content
          for (let section of this.content) {
            if (section.acf_fc_layout === 'columns') {
              //make new array with row-grouped content
              section.rowGroups = [];
              let rowGroup = [];
              section.rowGroups.push(rowGroup);
              let index = 0;
              let columnCount = section.column_count;
              for (let contentItem of section.content) {
                contentItem.contentIndex = index;
                rowGroup.push(contentItem);
                index++;
                if (index % columnCount === 0 && index !== section.content.length) {
                  rowGroup = [];
                  section.rowGroups.push(rowGroup);
                }
              }
            }
          }
          // grab other acf related variables
          this.pageCssClass = pageData.acf.page_css_class;
          this.showBlogHeading = pageData.acf.show_blog_heading;
          this.postTitle = pageData.title.rendered;
          this.postDate = new Date(pageData.date);
          this.pagesService.getAuthor(pageData.author)
            .subscribe((author) => {
              this.postAuthor = author;
            });
          setTimeout(() => {
            this.makeAbstract(false);
            document.querySelector('html').scrollTop = 0;

            this.showIframes = true;
            this.enableAnchorScrolls();
            this.convertLinksToRoutes();
          }, 10);
        }
      );
  }

  convertLinksToRoutes() {
    let links = this.elementRef.nativeElement.querySelectorAll('a');
    for (let link of links) {
      let url = link.getAttribute('href');
      let domainIsLocal = url.indexOf(document.location.origin) === 0;
      if (url && url.indexOf('http') !== 0 || domainIsLocal) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          let route = domainIsLocal ? url.substring(document.location.origin.length) : url;
          this.router.navigate([route]);
        });
      }
    }
  }

  ngOnInit() {

    this.makeAbstract(true);

    this.route.params.forEach((params: Params) => {

      let slug = params['slug'];

      if (slug !== undefined) {
        this.content = null;
        this.getContent(slug);
      }

    });
  }

  resizeIframe(event: Event, section: any) {

    let element: any = event.currentTarget;

    var doc = element.contentWindow.document;
    var body_ = doc.body, html_ = doc.documentElement;

    //add styles
    let styleElements = Array.from(document.querySelectorAll('style'));
    for (let styleElement of styleElements) {
      html_.appendChild(styleElement.cloneNode(true));
    }
    if (section.html_class && section.html_class !== '') {
      html_.classList.add(section.html_class);
    }

    //resize
    var height = Math.max(body_.scrollHeight, body_.offsetHeight, html_.clientHeight, html_.scrollHeight, html_.offsetHeight);
    var width = Math.max(body_.scrollWidth, body_.offsetWidth, html_.clientWidth, html_.scrollWidth, html_.offsetWidth);

    setTimeout(() => {
      element.style.height = height + 'px';
    }, 10);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    //console.log('destroy '+this.slug);
    //this.makeAbstract(true);
  }

  ngOnChanges() {

  }

  public canDeactivate(): Observable<boolean> {
    this.makeAbstract(true);
    return Observable.of(true).delay(AppConfig.transitionTime);
  }

}




// WEBPACK FOOTER //
// ./src/app/pages/page-single/page-single.component.ts